module.exports = {
  BASE_URL: 'https://platform.qdwanlin.com'
}
